import React from "react";
import { LuTrash2 as FaTrash } from "react-icons/lu";

const DeleteModal = ({ isOpen, onClose, onConfirm, message, isDeleting }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className="bg-white dark:bg-[#23272c] rounded-xl shadow-lg w-[90%] max-w-md p-6 relative">
                {/* Close Button */}
                <button
                    className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                    onClick={onClose}
                >
                    ✖
                </button>

                {/* Icon */}
                <div className="flex items-center mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-blue-50">
                        <FaTrash className="text-[#327691] text-xl" />
                    </div>
                </div>

                {/* Title */}
                <h2 className="text-lg font-semibold mb-2">
                    Delete Confirmation
                </h2>

                {/* Message */}
                <p className="text-gray-600 dark:text-gray-300 mb-6">
                    {message ? message : "Are you sure you want to delete this item?"}
                </p>

                {/* Actions */}
                <div className="flex gap-4">
                    <button
                        onClick={onClose}
                        className="px-5 py-2 flex-1 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-[#2A2A2A] text-gray-700 dark:text-white hover:bg-gray-100 dark:hover:bg-[#333]"
                        disabled={isDeleting}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-5 py-2 flex-1 rounded-lg bg-[#327691] text-white hover:bg-[#285c6b]"
                        disabled={isDeleting}
                    >
                        {isDeleting ? "Deleting..." : "Delete"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteModal;
